module.exports = __webpack_public_path__ + "static/cag4-24c4a27f38031814c7d2b70e473cebb3.png";